import { render, staticRenderFns } from "./VAbsenceDetails.vue?vue&type=template&id=0f067679&"
import script from "./VAbsenceDetails.vue?vue&type=script&lang=js&"
export * from "./VAbsenceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports